// extracted by mini-css-extract-plugin
export default {"SkeletonTable":"table-skeleton_SkeletonTable__ldALK"};